module.exports = __webpack_public_path__ + "img/JOC_3098.f5d29a47.jpg";